import Axios from "axios";
// import VueCookies from 'vue-cookies'
// import router from '../router';
// import { message } from 'element-ui'
// import store from "../store"

// 创建Axios实例
// Axios.defaults.withCredentials = false
const service = Axios.create({
  timeout: 50000, // 请求超时时间
  // baseURL: "/api"
  baseURL: "https://lcsy.znhospital.cn/api"
  // baseURL: "http://47.93.189.238:18990/api"
  // baseURL: "https://www.znhospital.com/ywsy/api"
  // baseURL: "https://lcsy.znhospital.cn/api"
});
Axios.defaults.withCredentials = true;
const err = error => {
  if (error.response) {
    // store.state.loadding = false; //在请求发出之前进行一些操作
    // let that = this;
    let data = error.response.data;
    // const token = VueCookies.get('token');
    // console.log("------异常响应------", token)
    console.log("------异常响应------", error.response.status);
    switch (error.response.status) {
      case 403:
        message.error({
          message: "系统提示",
          description: "拒绝访问",
          duration: 4
        });
        break;
      case 500:
        //notification.error({ message: '系统提示', description:'Token失效，请重新登录!',duration: 4})
        // if (token && data.message.includes("Token失效")) {
        //   // update-begin- --- author:scott ------ date:20190225 ---- for:Token失效采用弹框模式，不直接跳转----
        //   message.error({
        //     content: '很抱歉，登录已过期，请重新登录',
        //     duration: 1
        //   })
        //   // VueCookies.remove("token");
        //   localStorage.removeItem("username");
        //   router.push({
        //     path: '/login'
        //   });
        //   // update-end- --- author:scott ------ date:20190225 ---- for:Token失效采用弹框模式，不直接跳转----
        // }
        break;
      case 404:
        message.error({
          message: "系统提示",
          description: "很抱歉，资源未找到!",
          duration: 4
        });
        break;
      case 504:
        message.error({ message: "系统提示", description: "网络超时" });
        break;
      default:
        message.error({
          message: "系统提示",
          description: data.message,
          duration: 4
        });
        break;
    }
  }
  return Promise.reject(error);
};
// request拦截器
service.interceptors.request.use(
  config => {
    // const token = VueCookies.get('token');
    // token ? config.headers['X-Access-Token'] = token : 'null';
    // store.state.loadding = true; //在请求发出之前进行一些操作
    return config;
  },
  error => {
    Promise.reject(error);
  }
);

// respone拦截器
service.interceptors.response.use(response => {
  // store.state.loadding = false;//在这里对返回的数据进行处理
  return response;
});

export default service;



// WEBPACK FOOTER //
// ./src/request/golbal.js